import * as React from 'react';
import { Helmet } from 'react-helmet';

type FaqObj = {
  question: string;
  answer: string;
}

interface FAQSchemaDataProps {
  faqData: FaqObj[];
}

const getSchema = (faqData: FaqObj[]) => {
  const faqsForSchema = faqData.filter(faq => !!faq.question && !!faq.answer);
  return {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqsForSchema.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};

export const FAQSchema = ({ faqData }: FAQSchemaDataProps) => {
  if (!faqData.length) return null;
  const scriptContent = getSchema(faqData);

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(scriptContent)}</script>
    </Helmet>
  );
};
